import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import NotFound from "../modules/admin/NotFound";
import LoadingScreen from "../components/LoadingScreen";
import { useUser } from "src/business-types/grocery/components/UserContext";
import Home from "src/business-types/laundry/modules/home/Home";
import ConfigurationLayout from "../configurations/ConfigurationLayout";
import PrintSettingsTab from "../configurations/PrintSettingsTab";
import BusinessOperationTab from "../configurations/BusinessOperationTab";
import TableBillingTab from "../configurations/TableBillingTab";
import TermsConditionsTab from "../configurations/TermsConditionsTab";
import QRCodesTab from "../configurations/QRCodesTab";
import ReportsTab from "../configurations/ReportsTab";
import PrintConfig from "src/business-types/grocery/layouts/profile/PrintConfig";
import FoodTypesTab from "../configurations/FoodTypesTab";
import Dashboard from "src/business-types/laundry/modules/dashboard/Dashboard";
import OrderSearch from "src/business-types/laundry/modules/orders/OrderSearch";
import Profile from "../modules/profile/Profile";
import OrderDisplay from "src/business-types/laundry/modules/orders/OrderDisplay";
import Ledger from "../modules/ledgers/list/Ledger";
import LedgerData from "../modules/ledgers/details/LedgerData";
import DailyReport from "../modules/reports/DailyReport";
import CarWashHome from "src/business-types/car-wash/modules/pages/CarWashHome";
import CarOrderList from "src/business-types/car-wash/modules/orders/CarOrderList";
import CarOrderDetails from "src/business-types/car-wash/modules/orders/carOrderDetails/CarOrderDetails";
import SaloonOrder from "src/business-types/saloon/modules/orders/SaloonOrder";
import SaloonOrderDisplay from "src/business-types/saloon/modules/orders/SaloonOrderDisplay";
import CarProfile from "src/archive/car-wash/CarProfile";
import CarWash from "src/business-types/car-wash/modules/pages/CarWash";
import CarPaymentDetails from "src/business-types/car-wash/modules/pages/CarPaymentDetails";
import CarPaymentType from "src/business-types/car-wash/modules/pages/CarPaymentType";
import CarPrinter from "src/business-types/car-wash/modules/pages/CarPrinter";
import VechicleHome from "src/business-types/vechicle-retailer/modules/home/VechicleHome";
import SaloonHome from "src/business-types/saloon/modules/home/SaloonHome";
import Service from "src/business-types/saloon/modules/home/Service";
import SaloonDeshboard from "src/business-types/saloon/modules/dashboard/SaloonDeshboard";
import BussienessOperation from "../modules/reports/BussienessOperation";
import Ressetting from "src/archive/Restaurant/Ressetting";
import Resreservation from "src/archive/Restaurant/Resreservation";
import Reskitchen from "src/archive/Restaurant/Reskitchen";
import Reshome from "src/business-types/restaurant/modules/home/Reshome/Reshome";
import Resdeshboard from "src/business-types/restaurant/modules/dashboard/Resdeshboard";
import Resorders from "src/business-types/restaurant/modules/orders/Resorders";
import Calculator from "../modules/settings/Tools/Calculator";
import BranchesPage from "../modules/settings/branches/BranchesPage";
import CategoriesPage from "../modules/settings/categories/CategoriesPage";
import AddProduct from "../modules/settings/AddProduct";
import CustomerData from "../modules/settings/CustomerData";
import Configurations from "../modules/settings/configuration/Configurations";
import Staff from "../modules/settings/Staff";
import Resbranch from "src/archive/Restaurant/Resbranch";
import Resuser from "src/archive/Restaurant/Resuser";
import Rescategory from "src/archive/Restaurant/Rescategory";
import Resaddmenu from "src/archive/Restaurant/Resaddmenu";
import Rescustomer from "src/archive/Restaurant/Rescustomer";
import ResConfigurations from "src/archive/Restaurant/ResConfigurations";
import AddAgent from "src/shared/modules/settings/User/components/User";
import PermissionRoute from "../components/PermissionRoute";
import Respayment from "src/business-types/restaurant/modules/home/respayment/Respayment";
import ResRunningOrder from "src/business-types/restaurant/modules/running-order/ResRunningOrder";
import PrintConfigTab from "../configurations/PrintConfig";
import Header from "../modules/header/Header";
import Menu from "../modules/menu/Menu";
import PosConfig from "../configurations/PosConfig";
import PaymentGatewayConfig from "../configurations/RazorPayConfig";
import PrintConfiguration from "../configurations/commonPrint/PrintConfiguration";
import Catalog from "../catalog/catalog";

function ProtectedRoutes() {
  const token = sessionStorage.getItem("jsonwebtoken");
  const [pageTitle, setPageTitle] = useState<string>();
  const location = useLocation();
  useEffect(() => {
    setPageTitle("");
  }, [location]);
  const { user } = useUser();
  if (!token) {
    return (
      <Routes>
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  }
  if (!user) {
    return <LoadingScreen />;
  }

  const Locatesetting: React.FC = () => {
    return (
      <div>
        <Routes>
          <Route path="/Resbranch" element={<Resbranch />} />
          <Route path="/Resuser" element={<Resuser />} />
          <Route path="/Rescategory" element={<Rescategory />} />
          <Route path="/Resaddmenu" element={<Resaddmenu />} />
          <Route path="/Rescustomer" element={<Rescustomer />} />
          <Route path="/Configurations" element={<ResConfigurations />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    );
  };

  const SettingRoutes: React.FC = () => {
    return (
      <div>
        <Routes>
          <Route path="/location" element={<BranchesPage />} />
          <Route path="/add-agent" element={<AddAgent />} />
          <Route path="/add-product" element={<AddProduct />} />
          <Route path="/add-category" element={<CategoriesPage />} />
          <Route path="/customer-data" element={<CustomerData />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    );
  };
  const CarsettingRoutes: React.FC = () => {
    return (
      <div>
        <Routes>
          <Route path="/car-products" element={<AddProduct />} />
          <Route path="/car-categorys" element={<CategoriesPage />} />
          <Route path="/car-customer" element={<CustomerData />} />
          <Route path="/car-branch" element={<BranchesPage />} />
          <Route path="/car-users" element={<AddAgent />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    );
  };

  const Vechicle: React.FC = () => {
    return (
      <div>
        <Routes>
          <Route path="/vechicle-branch" element={<BranchesPage />} />
          <Route path="/vechicle-user" element={<AddAgent />} />
          <Route path="/vechicle-category" element={<CategoriesPage />} />
          <Route path="/vechicle-product" element={<AddProduct />} />
          <Route path="/vechicle-customer" element={<CustomerData />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    );
  };

  const Restaurant: React.FC = () => {
    return (
      <div>
        <Routes>
          <Route path="/Resbranch" element={<BranchesPage />} />
          <Route path="/Resuser" element={<AddAgent />} />
          <Route path="/Rescategory" element={<CategoriesPage />} />
          <Route path="/Resaddmenu" element={<AddProduct />} />
          <Route path="/Rescustomer" element={<CustomerData />} />
          <Route path="/Resconfigurations" element={<Configurations />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    );
  };

  const SaloonRoutes: React.FC = () => {
    return (
      <div>
        <Routes>
          <Route path="/style-branch" element={<BranchesPage />} />
          <Route path="/style-user" element={<AddAgent />} />
          <Route path="/style-staff" element={<Staff />} />
          <Route path="/style-category" element={<CategoriesPage />} />
          <Route path="/style-product" element={<AddProduct />} />
          <Route path="/style-customer" element={<CustomerData />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/v1/tools" element={<Calculator />} />
        </Routes>
      </div>
    );
  };
  return (
    <div className="w-screen h-screen flex flex-col flex-1">
      <Header Header="My Header" pageTitle={pageTitle} />
      {/* <div className="w-full h-[95%] flex"> */}
      <div className="flex flex-1 w-full h-[95%] overflow-hidden">
        <Menu />
        <main className="flex-1 overflow-auto bg-white">
          <Routes>
            {/* <Route element={<SalonLayout />}> */}
            <Route path="/home" element={<Home />} />
            <Route path="/confiuration" element={<ConfigurationLayout />}>
              <Route path="print-settings" element={<PrintSettingsTab />} />
              <Route path="business-operation" element={<BusinessOperationTab />} />
              <Route path="table-billing" element={<TableBillingTab />} />
              <Route path="terms-conditions" element={<TermsConditionsTab />} />
              <Route path="qr-codes" element={<QRCodesTab />} />
              <Route path="reports" element={<ReportsTab />} />
              <Route path="print-config" element={<PrintConfig />} />
              <Route path="food-types" element={<FoodTypesTab />} />
              <Route index element={<Navigate to="print-settings" replace />} />
              <Route path="pos-config" element={<PosConfig />} />
              <Route path="payment-apps" element={<PaymentGatewayConfig />} />
              {/* <Route path="receipt-custom" element={<PrintConfiguration />} /> */}
            </Route>
            <Route
              path="/dashboard"
              element={
                <PermissionRoute permission="dashboard_view">
                  <Dashboard />
                </PermissionRoute>
              }
            />
            <Route
              path="/order"
              element={
                <PermissionRoute permission="order_view">
                  <OrderSearch />
                </PermissionRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PermissionRoute permission="dashboard_view">
                  <Profile />
                </PermissionRoute>
              }
            />
            <Route
              path="/order-details/:orderid"
              element={
                <PermissionRoute permission="order_view">
                  <OrderDisplay />
                </PermissionRoute>
              }
            />
            <Route
              path="/catalog"
              element={
                <PermissionRoute permission="catalog_view">
                  <Catalog />
                </PermissionRoute>
              }
            />

            <Route
              path="/edit/*"
              element={
                <PermissionRoute permission="management_view">
                  <SettingRoutes />
                </PermissionRoute>
              }
            />
            <Route path="/setting/*" element={<Vechicle />} />
            <Route
              path="/Ressettings/*"
              element={
                <PermissionRoute permission="management_view">
                  <Restaurant />
                </PermissionRoute>
              }
            />
            <Route
              path="/saloonedit/*"
              element={
                <PermissionRoute permission="management_view">
                  <SaloonRoutes />
                </PermissionRoute>
              }
            />
            <Route
              path="/ledger"
              element={
                <PermissionRoute permission="customer_view">
                  <Ledger />
                </PermissionRoute>
              }
            />
            <Route
              path="/ledger/:customerId"
              element={
                <PermissionRoute permission="customer_view">
                  <LedgerData />
                </PermissionRoute>
              }
            />
            <Route path="/sales-report" element={<DailyReport />} />
            <Route path="/new-order" element={<CarWashHome />} />
            <Route
              path="/order-list"
              element={
                <PermissionRoute permission="order_view">
                  <CarOrderList />
                </PermissionRoute>
              }
            />
            <Route
              path="/car-order-details/:orderid"
              element={
                <PermissionRoute permission="order_view">
                  <CarOrderDetails />
                </PermissionRoute>
              }
            />
            <Route
              path="/saloon-order"
              element={
                <PermissionRoute permission="order_view">
                  <SaloonOrder />
                </PermissionRoute>
              }
            />
            <Route
              path="/saloon-order-display/:orderid"
              element={
                <PermissionRoute permission="order_view">
                  <SaloonOrderDisplay />
                </PermissionRoute>
              }
            />
            <Route
              path="/car-setting/*"
              element={
                <PermissionRoute permission="management_view">
                  <CarsettingRoutes />
                </PermissionRoute>
              }
            />
            <Route path="/car-profile" element={<CarProfile />} />
            <Route path="/car-wash/:categoryId" element={<CarWash />} />
            <Route path="/car-payment-cash" element={<CarPaymentDetails />} />
            <Route path="/car-Payment" element={<CarPaymentType />} />
            <Route path="/car-message-conformation" element={<CarPrinter />} />
            <Route path="/vechicle-home" element={<VechicleHome />} />
            <Route path="/res-profile" element={<Profile />} />
            <Route path="/saloon-Home" element={<SaloonHome />} />
            <Route path="/saloon-service" element={<Service />} />
            <Route
              path="/saloon-deshboard"
              element={
                <PermissionRoute permission="dashboard_view">
                  <SaloonDeshboard />
                </PermissionRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
            <Route path="/tools" element={<Calculator />} />
            <Route path="/Reshome" element={<Reshome />} />
            <Route
              path="/Resdeshboard"
              element={
                <PermissionRoute permission="dashboard_view">
                  <Resdeshboard />
                </PermissionRoute>
              }
            />
            <Route
              path="/Resorders"
              element={
                <PermissionRoute permission="order_view">
                  <Resorders />
                </PermissionRoute>
              }
            />
            <Route path="/Reskitchen" element={<Reskitchen />} />
            <Route path="/Resreservations" element={<Resreservation />} />
            <Route path="/Resreservation" element={<Resreservation />} />
            <Route path="/Respayment/:id" element={<Respayment />} />
            <Route
              path="/Ressettings"
              element={
                <PermissionRoute permission="management_view">
                  <Ressetting />
                </PermissionRoute>
              }
            />
            <Route
              path="/Ressettings/*"
              element={
                <PermissionRoute permission="management_view">
                  <Locatesetting />
                </PermissionRoute>
              }
            />
            <Route path="/Resrunning-order" element={<ResRunningOrder />} />
            <Route path="/sales-summary" element={<BussienessOperation />} />
            <Route path="/configuration" element={<ConfigurationLayout />}>
              <Route index element={<Navigate to="print-settings" />} />

              <Route path="print-settings" element={<PrintSettingsTab />} />
              <Route path="table-billing" element={<TableBillingTab />} />
              <Route path="terms-conditions" element={<TermsConditionsTab />} />
              <Route path="qr-codes" element={<QRCodesTab />} />
              <Route path="reports" element={<ReportsTab />} />
              <Route path="business-operation" element={<BusinessOperationTab />} />
              <Route path="food-types" element={<FoodTypesTab />} />
              <Route path="print-config" element={<PrintConfigTab />} />
              <Route path="pos-config" element={<PosConfig />} />
              <Route path="payment-apps" element={<PaymentGatewayConfig />} />
              {/* <Route path="receipt-custom" element={<PrintConfiguration />} /> */}
            </Route>
            <Route path="*" element={<NotFound />} />
            {/* </Route> */}
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default ProtectedRoutes;
